<p class="form-field-heading">{{header}}</p>

<div class="row form2">
    <div class="col-sm-8">
        <div class="file-placeholder">
            <input type="file" class="fileUpload" name="photo"
                   appAcceptFormats=".jpg,.jpeg,.png" (change)="upload($event)" toggleCamera="SecureFile">
            <div class="file-browse">
                <span class="file-browse-txt">{{placeHolder}}</span>
                <span class="browse"><i class="material-icons">file_upload</i></span>
            </div>
        </div>
    </div>
</div>
